import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, filter } from "rxjs/operators";

import { TransferStateService } from "src/app/core/services/transfer-state.service";
import { Product } from "../models/product.model";

@Injectable({
  providedIn: "root",
})
export class ProductService extends TransferStateService {
  path = "products";

  index(): Observable<Product[]> {
    try {
      return this.http
        .get<any>(`${this.apiUrl}/${this.path}`)
        .pipe(filter((response) => !!response))
        .pipe(map((response) => response.data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  show(id: string | number): Observable<Product> {
    try {
      return this.http
        .get<any>(`${this.apiUrl}/${this.path}/${id}`)
        .pipe(filter((response) => !!response))
        .pipe(map((response) => response.data));
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  search(arg: string): Observable<Product[]> {
    return this.index();
  }
}
